import "./loader.css";
export default  function Loader(){
  return <div class="loader"></div>;
};